import { environment } from "src/environments/environment";
import { Funder } from "../models/funder";

export function getCurrentApiDomain(urlSuffix: string): string {
  return `${getCurrentBaseDomain()}/api${urlSuffix}`;
}


export function getCurrentBaseDomain(): string {
  let currentDomain = getCurrentDomain();

  if (currentDomain == 'dev.tgicarenet.com') {
    return `https://api.dev.tgicarenet.com`;
  } else if (currentDomain == 'tgicarenet.com') {
    return `https://api.tgicarenet.com`;
  } else {
    return `https://${currentDomain.replace(/^([^\.]+)\./, '$1.api.')}`;
  }
}


export function getCurrentDomain(): string {
  let currentDomain = (window.location.hostname == 'localhost' ? environment.currentApiHostname : window.location.hostname) ?? '';
  if (localStorage.getItem('current_portal_domain')) {
    currentDomain = localStorage.getItem('current_portal_domain') ?? currentDomain;
  }
  return currentDomain;
}


export function getCurrentFunder(): Funder {
  const fundersList = JSON.parse(localStorage.getItem('funders_list')!).map((el: any) => new Funder(el));
  const currentFunderDomain = localStorage.getItem('current_portal_domain');
  return fundersList.filter((el: any) => el.funder_settings.domain == currentFunderDomain)[0];
}

export function getCurrentFunderPrimaryColor(): string {
  return getCurrentFunder().primary_color;
}
